import { Borders, Row, Workbook, Worksheet } from "exceljs"
import { AccountHeaderType, LinkAccountType } from "pages/Setup/Account/LinkAccount/types"

type ExportExcel = {
  dataHeader: AccountHeaderType[]
  data: LinkAccountType[]
  companyName?: string
}

export const exportExcel = async ({ dataHeader, data }: ExportExcel) => {
  const workbook = new Workbook()
  const worksheet = workbook.addWorksheet("Sheet 1")
  const columns = [
    "CODE",
    "DESCRIPTION",
    "NUMBER",
    "COA NAME",
  ]
  worksheet.views = [{ showGridLines: false }]

  worksheet.mergeCells(2, 1, 1, columns.length)

  // Title
  makeTitle(worksheet)

  dataHeader?.forEach((da, index) => {
    if (index > 0) {
      worksheet.addRow([" "])
    }

    worksheet.addRow([da.Header])

    const headers = worksheet.addRow(columns)
    headers.font = { bold: true }
    headers.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF8C308" },
      }
      cell.border = {
        top: { style: "thin", color: { argb: "000000" } },
        left: { style: "thin", color: { argb: "000000" } },
        bottom: { style: "thin", color: { argb: "000000" } },
        right: { style: "thin", color: { argb: "000000" } },
      }
    })

    let itemRow: Row

    const cellBorder: Partial<Borders> = {
      top: { style: "thin", color: { argb: "000000" } },
      left: { style: "thin", color: { argb: "000000" } },
      bottom: { style: "thin", color: { argb: "000000" } },
      right: { style: "thin", color: { argb: "000000" } },
    }

    da.LinkAccount?.forEach(la => {
      const coa = data.find(d => d.linked_account_code === la.linked_account_code)

      itemRow = worksheet.addRow([la.linked_account_code, la.description, coa?.coa_code ?? "", coa?.coa_name ?? ""])

      itemRow.eachCell((cell) => {
        cell.border = cellBorder
      })
    })
  })

  // create xlsx
  await workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    })
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = "link-account-purchase.xlsx"
    a.click()
    URL.revokeObjectURL(url)
  })
}

function makeTitle(worksheet: Worksheet) {
  const titleCell = worksheet.getCell(1, 2)
  titleCell.value = "LINK ACCOUNT PURCHASE"
  titleCell.alignment = {
    vertical: "middle",
    horizontal: "center",
    wrapText: true,
  }
  titleCell.font = { bold: true, size: 15 }

  worksheet.getColumn(2).width = 20
}